const curry = require('lodash/curry');
const pipe = require('lodash/flow');

module.exports = {
  curry,
  pipe,
  __: curry.placeholder,
};
